import { render } from "./Reset.vue?vue&type=template&id=399f02a0&scoped=true&ts=true"
import script from "./Reset.vue?vue&type=script&lang=ts"
export * from "./Reset.vue?vue&type=script&lang=ts"

import "./Reset.vue?vue&type=style&index=0&id=399f02a0&lang=scss&scoped=true"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399f02a0"]])

export default __exports__